(function($, undefined) {
	
	'use strict';
    var currPage;
    var sendBillsBackBtn;
    var refundBtn;
    var refundCheck;
    var refundConfirmBtn;
    var refundCancelBtn;
    var refundActionCancelBtn;
    var refundActionAcceptBtn;
    var editTicketsNames;
    var chequeBtn;
    var cancelPaymentBtn;
    var resendBillsToggleBtn;
    var resendBillsBtn;
    
    /* Sends the bill and all tickets back to buyer */
	var sendBillsBack = function(){
        var t = $(this);
        var ctn = t.closest(".send-bills-form");
        var id = t.attr("data-id");
        var email = ctn.find("input[name=email]").val();
        var firstName = ctn.find("input[name=fname]").val();
        var lastName = ctn.find("input[name=lname]").val();
        var overwrite = ctn.find("input[name=overwrite]").is(':checked');
        
        var url = "/action/epManageTransactions?sendAgain=true";
        url += "&paymentId="+id;
        url += "&email="+email;
        url += "&firstName="+firstName;
        url += "&lastName="+lastName;
        url += "&overwrite="+overwrite;
        
        t.addClass("disabled");
        ajax(url, function(){
            ctn.find(".success-msg").slideDown();
            window.setTimeout(function(){
                ctn.find(".success-msg").slideUp();
                 t.removeClass("disabled");
            }, 3000);
            if($(".vc-confirm-step-btn.email").length !== 0){ // virtual cashier, step 5
                $(".vc-confirm-step-btn.email").addClass("checked");
            }
        },true);        
    };

    /* Organizer side : creates a request to admin (alert & payment) to proceed to a refund */
    var refundAmt = function() {
        var t = $(this);
        var id = t.attr("data-id");
        var tickets_selected = t.closest(".refund-form").find(".purchase-payment-list-ctn tr.selected");
        var tickets_all = t.closest(".refund-form").find(".purchase-payment-list-ctn tr");
        var amount = trimAmount(t.closest(".refund-form").find(".refund-amount-ctn input[name='amount']").val());        
        var allCheck = t.closest(".refund-form").find(".refund-amount-ctn input[name='refund-all-admin']");
        var all = allCheck.length !== 0 && allCheck.is(":checked");
        if((amount !== "" && amount > 0) || tickets_selected.length !== 0 || all){
            t.addClass("disabled");
            var tickets = all ? getSelectedTickets(tickets_all) : getSelectedTickets(tickets_selected);
            var url = "/action/epRefund?ajax=true&org=true";
            url += "&amount=" + amount;
            url += "&paymentId=" + id;
            url += "&all=" + all;
            url += "&selectedTickets=" + tickets;
            
            ajax(url, function(response) {
                if(response.indexOf("success") !== -1){
                    t.closest(".refund-form").find(".error-funds-message").slideUp();
                    window.location = window.location.href.split("?")[0];
                }
                else{
                    t.removeClass("disabled");
                    t.closest(".refund-form").find(".error-funds-message").slideDown();
                }
            }, true);
        }
    };
    
    var getSelectedTickets = function(elmts) {
        var ids = "";

        elmts.each(function() {
            var id = $(this).attr("data-id");
            if(typeof id !== "undefined")
            {
                ids += $(this).attr("data-id") + ",";
            } 
        });

        return ids;
    };
    
    var trimAmount = function(amt){
        if(amt.indexOf(",") !== -1){
            amt = amt.replace(",", ".");
        }
        if(amt.indexOf("$") !== -1){
            amt = amt.replace("$","");
        }
        amt = amt.trim();
        return amt;
    };
    
    var toggleCheckLine = function(){
        var t = $(this);
        var price = parseFloat(t.closest("td").attr("data-price"));
        var totalInput = t.closest(".refund-form").find("input[name='amount']");
        var total = totalInput.val();
        var s = (total.trim() === "") ? parseFloat(0) : parseFloat(total.trim());
        
        if(t.is(":checked")){
            t.closest("tr").addClass("selected");  
            totalInput.val((s + price).toFixed(2));          
        }
        else{
            t.closest("tr").removeClass("selected");  
            var sum = ((s - price) < 0)? 0 : (s - price);  
            totalInput.val(sum.toFixed(2));          
        }
        
    };
    
    /* Confirmation from organizer before he actually creates a request for a refund to Admin */
    var confirmRefund = function(){
        var t = $(this);
        var amount = trimAmount(t.closest(".refund-form").find(".refund-amount-ctn input[name='amount']").val());
        var tickets = t.closest(".refund-form").find(".purchase-payment-list-ctn tr.selected td");
        var allCheck = t.closest(".refund-form").find(".refund-amount-ctn input[name='refund-all-admin']");
        var all = allCheck.length !== 0 && allCheck.is(":checked");
        if((amount !== "" && amount > 0) || tickets.length !== 0 || all){
            t.addClass("disabled");
            t.closest(".refund-form").find(".form-overlay").addClass("visible");
            t.closest(".refund-form").find(".confirm-message-refund").slideDown();
            t.closest(".refund-form").find(".purchase-payment-list-ctn tr:not(.selected) td").slideUp();
        }
    };
    
    var cancelRefund = function(){
        var t = $(this);
        refundConfirmBtn.removeClass("disabled");
        t.closest(".refund-form").find(".form-overlay").removeClass("visible");
        t.closest(".refund-form").find(".confirm-message-refund").slideUp();
        t.closest(".refund-form").find(".error-funds-message").slideUp();
        t.closest(".refund-form").find(".purchase-payment-list-ctn tr:not(.selected) td").slideDown();
    };
    
    /* Request for refund already created : this cancels it. */
    var cancelRefundPayment = function(){
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        
        var url = "/action/epRefund?ajax=true";
        url += "&paymentId=" + id;
        url += "&cancel=true";
        url += "&organizer=true";
        
        ajax(url, function(response) {
            var ctn = t.closest("tr");
            var text = ctn.find(".payment-status").attr("data-canceled");
            ctn.find(".payment-status-text").html(text);
            t.remove();
            t.closest(".table-action-btns-ctn").find(".table-accept-refund-action").remove();
        }, true);
    };
    
    /* Request for refund already created : accept it. */
    var acceptRefundPayment = function(){
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        
        var url = "/action/epRefund?ajax=true";
        url += "&paymentId=" + id;
        
        ajax(url, function(response) {
            var ctn = t.closest("tr");
            var text = ctn.find(".payment-status").attr("data-refunded");
            ctn.find(".payment-status-text").html(text);
            t.remove();
            t.closest(".table-action-btns-ctn").find(".table-cancel-refund-action").remove();
        }, true);
    };
    
    var editInfos = function(){
        var mainCtn = $(this).closest(".ticket-owner-ctn");
        var ctn = $(this).closest(".ticket-owner-name-form");
        var id = ctn.attr("data-id");
        var fName = ctn.find("input[name=firstName]").val();
        var lName = ctn.find("input[name=lastName]").val();
        var email = ctn.find("input[name=email]").val();
        var company = ctn.find("input[name=company]").val();
        
        var url = "/action/epQR?ticketPaymentId="+id;
        url += "&firstName=" + fName;
        url += "&lastName=" + lName;
        url += "&email=" + email;
        url += "&company=" + company;        
        
        ajax(url, function(response) {
            var t = fName + " "+lName + " ("+email;
            if(company !== ""){
                t += " - "+company;
            }
            t+= ")";
            mainCtn.find(".ticket-names").text(t);
        }, true);
    };
    
    var updateCheckPayment = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var btn = $(".cheque-popup-btn-"+id);
        var paid = (t.hasClass("hijacker"))? !btn.hasClass("active") : true;
        var tr = t.closest("tr");
        
        var url = "/action/epManageTransactions?paymentId="+id;
        url += "&paid=" + paid;    
        
        t.addClass("disabled");
        ajax(url, function(response) {
            if(t.hasClass("hijacker")){
                btn.toggleClass("active");
                var ctn = t.closest(".popup-inner-content");
                if(paid){
                    ctn.find(".message-check-paid").css("display","none");
                    ctn.find(".message-check-not-paid").css("display","");
                } else {
                    ctn.find(".message-check-paid").css("display","");
                    ctn.find(".message-check-not-paid").css("display","none");                    
                }
            } else {
                btn.addClass("active");
                btn.removeClass("popup-btn");
                btn.unbind();
            }
            var text = tr.find(".payment-status").attr("data-paid");
            if(!paid){
                text = tr.find(".payment-status").attr("data-not-paid");
            }
            tr.find(".payment-status-text").text(text);
            tr.find(".popup-status").text(text);
            tr.find(".table-cancel-action").remove();
            tr.find(".table-send-bills-action").remove();
            t.removeClass("disabled");
        }, true);
    };
    
    var cancelCheckPayment = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var tr = t.closest("tr");
        
        var url = "/action/epManageTransactions?paymentId="+id;
        url += "&cancel=true";       
        
        t.addClass("disabled");
        ajax(url, function(response) {
            var text = tr.find(".payment-status").attr("data-canceled");
            tr.find(".payment-status-text").text(text);
            tr.find(".popup-status").text(text);
            tr.find(".table-send-bills-action").addClass("disabled");
            tr.find(".cheque-received-popup").addClass("disabled");
            tr.find(".table-cancel-action").addClass("disabled");
        }, true);
    };
    
    function resendBillsToggle(){
        $(".form-send-bills-by-date").toggleClass("hide");
    }
    
    function resendBillsByDate(){
        var form = $(".form-send-bills-by-date");
        formValidator.validateForm(form);
        if (!form.hasClass("has-error")) {
            var t = $(this);
            var startDay = $("input[name = 'startDateDay']", form).val();
            var startMonth = $("input[name = 'startDateMonth']", form).val();
            var startYear = $("input[name = 'startDateYear']", form).val();
            var startHour = $("input[name = 'startDateHour']", form).val();
            var startMinute = $("input[name = 'startDateMinute']", form).val();
            var endDay = $("input[name = 'endDateDay']", form).val();
            var endMonth = $("input[name = 'endDateMonth']", form).val();
            var endYear = $("input[name = 'endDateYear']", form).val();
            var endHour = $("input[name = 'endDateHour']", form).val();
            var endMinute = $("input[name = 'endDateMinute']", form).val();
            
            var message = tinymce.get("message").getContent();

            var url = "/action/epManageTransactions?sendAgainFromDate=true";
            url += "&startDay=" + startDay;
            url += "&startMonth=" + startMonth;
            url += "&startYear=" + startYear;
            url += "&startHour=" + startHour;
            url += "&startMinute=" + startMinute;
            url += "&endDay=" + endDay;
            url += "&endMonth=" + endMonth;
            url += "&endYear=" + endYear;
            url += "&endHour=" + endHour;
            url += "&endMinute=" + endMinute;
            url += "&message=" + encodeURIComponent(message);
            
            t.addClass("disabled");
            ajax(url, function () {
                
                t.removeClass("disabled");
            }, true);   
        }
    }
    
	var init = function (page) {
		currPage = $(page);
      
        sendBillsBackBtn = $(".send-bills-back-btn");
        sendBillsBackBtn.on("click", sendBillsBack);
        
        refundCheck = $(".refund-checkbox input[type='checkbox']");
        refundCheck.on("click", toggleCheckLine);        
        
        refundConfirmBtn = $(".refund-confirm-btn");
        refundConfirmBtn.on("click", confirmRefund);
        
        refundCancelBtn = $(".refund-cancel-btn");
        refundCancelBtn.on("click", cancelRefund);
        
        refundBtn = $(".refund-btn");
        refundBtn.on("click", refundAmt);        
        
        refundActionCancelBtn = $(".table-cancel-refund-action");
        refundActionCancelBtn.on("click", cancelRefundPayment);    
        
        refundActionAcceptBtn = $(".table-accept-refund-action");
        refundActionAcceptBtn.on("click", acceptRefundPayment);        
        
        editTicketsNames = $(".edit-tickets-names");
        editTicketsNames.on("click", editInfos);   
        
        chequeBtn = $(".cheque-received");
        chequeBtn.on("click", updateCheckPayment);   
        
        cancelPaymentBtn = $(".cancel-cheque-payment");
        cancelPaymentBtn.on("click", cancelCheckPayment);   
        
        resendBillsToggleBtn = $(".resend-bills-by-date");
        resendBillsToggleBtn.on("click", resendBillsToggle);   
        
        resendBillsBtn = $(".send-bills-by-date-btn");
        resendBillsBtn.on("click", resendBillsByDate);   
        
	};
	
    	
	$(window).on("load",function(){
        init();
    });
})(jQuery);
